import _ from 'lodash';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import React, { useMemo } from 'react';
import { listPageTableRowStyling } from '../../styles/sxStyling';
import { Contact } from '../../types/Contact';
import { useGetAllPreferences } from '../../services/react-query/preferences';
import { PREFERENCES_VALID_KEYS } from '../../types/Preference';
import { RolePillsCell } from '../preferences/RolePillsCell';
import { UserConfigurableModule } from '../../types/User';
import DrawerLink from '../common/drawers/ModuleDrawer/DrawerLink';

interface AccountContactTableProps {
  contacts: Contact[];
}

const AccountContactTable = ({ contacts }: AccountContactTableProps) => {
  const { data: preferenceData } = useGetAllPreferences({
    params: {
      filters: { keys: [PREFERENCES_VALID_KEYS.CONTACT_ROLE] },
    },
  });

  const prefByUuid = useMemo(() => _.keyBy(preferenceData ?? [], 'uuid'), [preferenceData]);

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Role</TableCell>
            <TableCell>Title</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Phone</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {contacts.map((contact: Contact) => {
            return (
              <TableRow key={contact.uuid} sx={listPageTableRowStyling}>
                <TableCell>
                  <DrawerLink module={UserConfigurableModule.CONTACTS} uuid={contact.uuid}>{`${contact.first_name} ${contact.last_name}`}</DrawerLink>
                </TableCell>
                <TableCell>
                  <RolePillsCell rolesUuids={contact.roles_uuids} prefByUuid={prefByUuid} />
                </TableCell>
                <TableCell>{contact.contact_title_value}</TableCell>
                <TableCell>{contact.email}</TableCell>
                <TableCell>{contact.phone_1}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default AccountContactTable;
